import { ref, reactive } from '@vue/composition-api'

const usePagination = ({
  service, // required
  listHandler = v => v,
  sizes = [50, 100],
  params = {},
}) => {
  const isLoading = ref(false)
  const list = ref([])
  const queryParams = reactive({
    page: 1,
    size: sizes[0],
  })
  const listQuery = reactive({
    sizes,
    total: 0,
  })

  const getList = async () => {
    isLoading.value = true
    try {
      const { data: newList = [], pagination = {} } = await service({ ...queryParams, ...params })

      // may need some preprocess before setting the list

      list.value = await listHandler(newList)
      listQuery.total = parseInt(pagination.total_items, 0)
    } catch (error) {
      console.error(error)
    } finally {
      isLoading.value = false
    }
  }

  const updateListQuery = (obj) => {
    Object.keys(obj).forEach((key) => {
      queryParams[key] = obj[key]
    })
    getList()
  }

  const handleSizeChange = (size) => {
    updateListQuery({ size })
  }
  const handlePageChange = (page) => {
    updateListQuery({ page })
  }
  const handleQueryParamsUpdate = (value) => {
    updateListQuery(value)
  }

  return {
    isLoading,

    list,
    getList,

    listQuery,
    handleSizeChange,
    handlePageChange,
    handleQueryParamsUpdate,
  }
}

export default usePagination
